"use client";

import { Card } from "@mui/material";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { findContractedPlan, hasContractedPlan } from "@/helpers/customer-sales-product-helpers";
import ICustomerSalesProduct from "@/interfaces/customer-sales-product.interfaces";
import { CustomerMessages } from "@/messages/customer/customer.messages";

import PlanManagementCards from "../PlanManagementCards";
import PlanManagementHeader from "../PlanManagementHeader";

type Props = {
  data: ICustomerSalesProduct[];
  messages: CustomerMessages;
  onCancelPlan: (plan: ICustomerSalesProduct) => void;
};

export function ActivePlanView({ data, messages, onCancelPlan }: Props) {
  const activePlan = findContractedPlan(data);
  const customerHasContractedPlan = hasContractedPlan(data);

  if (!activePlan) {
    return (
      <>
        <PlanManagementHeader messages={messages} disableNewPlan={customerHasContractedPlan} />
        <Card sx={{ overflow: "hidden" }}>
          <MDBox
            p={4}
            textAlign="center"
            sx={{
              bgcolor: "grey.50",
              border: "1px dashed",
              borderColor: "grey.300",
              borderRadius: 2,
              m: 2.5,
            }}
          >
            <MDTypography variant="h6" color="text" fontWeight="regular">
              {messages.noActivePlanMessage}
            </MDTypography>
          </MDBox>
        </Card>
      </>
    );
  }

  return (
    <PlanManagementCards
      plan={activePlan}
      messages={messages}
      disableNewPlan={customerHasContractedPlan}
      onCancelPlan={onCancelPlan}
    />
  );
}

export default ActivePlanView;
